module.exports = __webpack_public_path__ + "img/icon-caja-roja.4b8d6fd7.svg";